<template>
  <!--
    position: fixed な要素を扱うためのコンポーネント
    slot props の "isPinned" または v-model に設定した Boolean 型の data により、現在固定状態かどうかを知ることができる
    slot 内部でだけ固定状態か否か分かれば十分な場合は slot props を使い、slot 外でも知る必要がある場合は v-model を使う

    slot props を使う例：
      <tk-sticky-item :top="123">
        <template v-slot="{ isPinned }">
          ... isPinned によって表示切り替え ...
        </template>
      </tk-sticky-item>

    v-model を使う例：
      <div>
        <tk-sticky-item :top="123" v-model="isMyStickyItemPinned">
          ...
        </tk-sticky-item>
        <div v-if="isMyStickyItemPinned">
          ... sticky item が固定状態の場合だけ表示される内容 ...
        </div>
      </div>
  -->
  <div
    ref="wrapper"
    class="tkStickyItem_wrapper"
    :style="{
      '--top': `${top}px`,
      '--z-index': zIndex,
    }"
  >
    <slot :is-pinned="isPinned"></slot>
  </div>
</template>

<script>
export default {
  name: 'TkStickyItem',

  model: {
    prop: '_isPinned',
  },

  props: {
    // position: relative な直近の祖先要素（無い場合は body）の左上座標を基準とした top 位置
    top: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: Number,
      default: undefined,
    },
    // eslint-disable-next-line vue/prop-name-casing
    _isPinned: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: undefined,
    },
  },

  data: () => ({
    isPinned: false,
    intersectionObserver: undefined,
  }),

  mounted() {
    // これが無い環境はほぼ存在しない
    // 実質 jest でのエラー回避用
    if (!('IntersectionObserver' in window)) return

    this.intersectionObserver = new IntersectionObserver(([e]) => {
      this.isPinned = e.intersectionRatio < 1
      this.$emit('input', this.isPinned)
    }, {
      threshold: [1],
      // 1px だけ交差判定対象(ビューポート)の上部を削ることで、要素が top に固定されるまでは 100% 交差、固定された瞬間に 1px の分だけ交差割合が減るということを利用して固定検知している
      // しかし、ビューポートとの交差判定では画面下部にはみ出ている要素も交差割合 100% 未満、すなわち固定中として判定されてしまう
      // それを防ぐため、ビューポートに十分大きなダミーボトムマージン 10000px を入れている
      rootMargin: `-${this.top + 1}px 0px 10000px 0px`,
    })
    this.intersectionObserver.observe(this.$refs.wrapper)
  },

  beforeDestroy() {
    this.intersectionObserver && this.intersectionObserver.disconnect()
  },
}
</script>

<style scoped lang="scss">
.tkStickyItem_wrapper {
  position: sticky;
  top: var(--top);
  z-index: var(--z-index);
}
</style>
